import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { TableExpanderCell, TableRow } from '@helsenorge/designsystem-react/components/Table';
import { Cell } from './cell';
export class Row extends React.PureComponent {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "triggerRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "toggleClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { expandableRowKey, rowKey, toggle } = this.props;
                if (toggle && expandableRowKey) {
                    toggle(expandableRowKey, rowKey);
                }
            }
        });
        Object.defineProperty(this, "focusOnTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.triggerRef.current) {
                    this.triggerRef.current.focus();
                }
            }
        });
        this.triggerRef = React.createRef();
    }
    createRow(columns, rowData, expandableRow, expanded) {
        const { tableId, expandableRowKey, isTwoDimensional, showDetailsText = 'Vis', hideDetailsText = 'Skjul', highlightText } = this.props;
        const newColumns = [];
        const expandableRowId = !isTwoDimensional ? `${tableId}-${expandableRowKey}` : '';
        if (expandableRow) {
            // Expand trigger column. Hidden on smaller screens.
            newColumns.push(_jsx(TableExpanderCell, { expanded: expanded, hideDetailsText: hideDetailsText, showDetailsText: showDetailsText, expandableRowId: expandableRowId }));
        }
        for (let i = 0; i < columns.length; ++i) {
            const column = columns[i];
            const element = column.props.cell;
            if (React.isValidElement(element)) {
                const props = {
                    columnKey: `${column.props.altTitle ? `${column.props.altTitle} / ` : ``}${column.props.title}`,
                    rowData,
                    key: column.props.name,
                    highlightText: highlightText,
                    altTitle: column.props.altTitle,
                };
                if (column.props.cell) {
                    newColumns.push(React.cloneElement(element, Object.assign({}, column.props.cell.props, props)));
                }
            }
            else {
                let processedJsonObjectName;
                let rowValue;
                const processedColName = column.props.name.split('.');
                if (processedColName.length > 1) {
                    const temp = rowData[processedColName[0]];
                    rowValue = temp[processedColName[1]];
                }
                else {
                    processedJsonObjectName = processedColName[0];
                    rowValue = rowData[processedJsonObjectName];
                }
                newColumns.push(_jsx(Cell, { columnKey: column.props.title, rowData: rowData, highlightText: highlightText, children: rowValue }, column.props.name));
            }
        }
        return newColumns;
    }
    render() {
        const { rowData, columns, rowClasses, expandableRow, expanded } = this.props;
        let cells = null;
        if (columns) {
            cells = this.createRow(columns, rowData, !!expandableRow, expanded);
        }
        return (_jsx(TableRow, { className: rowClasses, onClick: this.toggleClick, expandable: expandableRow, expanded: expanded, hideDetailsText: this.props.hideDetailsText, showDetailsText: this.props.showDetailsText, children: cells }, this.props.rowKey));
    }
}
